import join from 'url-join';
import { filterType, sortBy } from '../../util/constants';

import { asyncAction, http } from '../../util';
import actionTypes from './actionTypes';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');
const { EMAIL_NOT_LIKE, ROLE } = filterType;

export const getUsers = asyncAction({
  baseName: actionTypes.GET_USERS,
  action:
    action =>
    ({ excludeTestUsers = false, filters = [], sort = null }) =>
    dispatch => {
      dispatch(action.start());

      if (excludeTestUsers) {
        filters.push({
          filter: EMAIL_NOT_LIKE,
          value: [encodeURI('manual.foo|automation.com|external.com|uat.foo|automated.foo|perf.foo')]
        });
      }

      const builtFilters = filters.length
        ? filters
            .reduce((acc, { filter, value }) => {
              const values = Array.isArray(value) ? value.join(',') : value;
              const apiFilter = `filter=${filter}(${values})`;

              return `${acc}${apiFilter}&`;
            }, '')
            .slice(0, -1)
        : null;

      const filterString = builtFilters ? `?${builtFilters}` : '';
      const sortedFilterString = sort
        ? `${filterString}${filterString ? '&' : '?'}sort=${sort}&count=10000&fields=email,id`
        : filterString;

      return http
        .get(join(api2, `/users${sortedFilterString}`))
        .then(({ data: { objects: response } }) => {
          dispatch(action.success());
          return response;
        })
        .catch(error => dispatch(action.error(error)));
    }
});

export const fetchAdminUsers = asyncAction({
  baseName: actionTypes.FETCH_ADMIN_USERS,
  action:
    action =>
    ({
      additionalFilters = [],
      excludeTestUsers = true,
      reqRoles = ['GAMEDAY_PRODUCTION_SUPPORT', 'GAMEDAY_SUPER_USER'],
      sort = sortBy.ROLE_DESC
    }) =>
    dispatch => {
      dispatch(action.start());
      const filters = [...additionalFilters];

      if (reqRoles.length > 0) {
        filters.push({ filter: ROLE, value: reqRoles });
      }

      filters.push({ filter: 'active', value: true });

      return dispatch(getUsers({ excludeTestUsers, filters, sort }))
        .then(resUsers => {
          dispatch(action.success(resUsers));
          return resUsers;
        })
        .catch(error => dispatch(action.error(error)));
    }
});
